var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { serialize } from '@shoelace-style/shoelace';
import { LitElement } from 'lit';
import { property, state } from 'lit/decorators.js';
export class SgdfElement extends LitElement {
    /** Emits a custom event with more convenient defaults. */
    emit(name, options) {
        if (typeof name !== 'string') {
            return name;
        }
        else {
            const event = new CustomEvent(name, Object.assign({ bubbles: true, cancelable: false, composed: true, detail: {} }, options));
            this.dispatchEvent(event);
            return event;
        }
    }
    static define(name, elementConstructor = this, options = {}) {
        const currentlyRegisteredConstructor = customElements.get(name);
        if (!currentlyRegisteredConstructor) {
            customElements.define(name, class extends elementConstructor {
            }, options);
            return;
        }
        let newVersion = ' (unknown version)';
        let existingVersion = newVersion;
        if ('version' in elementConstructor && elementConstructor.version) {
            newVersion = ' v' + elementConstructor.version;
        }
        if ('version' in currentlyRegisteredConstructor &&
            currentlyRegisteredConstructor.version) {
            existingVersion = ' v' + currentlyRegisteredConstructor.version;
        }
        // Need to make sure we're not working with null or empty strings before doing version comparisons.
        if (newVersion && existingVersion && newVersion === existingVersion) {
            // If versions match, we don't need to warn anyone. Carry on.
            return;
        }
        // eslint-disable-next-line no-console
        console.warn(`Attempted to register <${name}>${newVersion}, but <${name}>${existingVersion} has already been registered.`);
    }
    constructor() {
        super();
        Object.entries(this.constructor.dependencies).forEach(([name, component]) => {
            this.constructor.define(name, component);
        });
    }
}
SgdfElement.version = '0.0.1';
SgdfElement.dependencies = {};
__decorate([
    property()
], SgdfElement.prototype, "dir", void 0);
__decorate([
    property()
], SgdfElement.prototype, "lang", void 0);
export class SgdfFormElement extends SgdfElement {
    constructor() {
        super(...arguments);
        this.fieldErrors = {};
        this.formErrors = [];
    }
    readFieldErrors(id) {
        var _a, _b;
        return (_b = (_a = this.fieldErrors) === null || _a === void 0 ? void 0 : _a[id]) === null || _b === void 0 ? void 0 : _b.join('\n');
    }
    readFormErrors() {
        var _a;
        return (_a = this.formErrors) === null || _a === void 0 ? void 0 : _a.join('\n');
    }
    resetErrors() {
        this.fieldErrors = {};
        this.formErrors = [];
    }
    fieldHasError(id) {
        var _a;
        const fieldError = (_a = this.fieldErrors) === null || _a === void 0 ? void 0 : _a[id];
        if (fieldError && Array.isArray(fieldError)) {
            return fieldError.length > 0;
        }
        return false;
    }
    formHasError() {
        return this.formErrors.length > 0;
    }
    getFormSchema() {
        throw new Error('Method not implemented.');
    }
    reset() {
        var _a;
        this.resetErrors();
        (_a = this.form) === null || _a === void 0 ? void 0 : _a.reset();
    }
    submit(e) {
        var _a, _b, _c, _d;
        e === null || e === void 0 ? void 0 : e.preventDefault();
        if (!this.form) {
            // eslint-disable-next-line no-console
            console.warn('Form element not found');
            return;
        }
        let detail = serialize(this.form);
        const schema = this.getFormSchema();
        const result = schema.safeParse(detail);
        if (result.success) {
            this.onSuccessfulSubmit(result.data);
            this.reset();
        }
        else {
            this.fieldErrors = (_b = (_a = result.error) === null || _a === void 0 ? void 0 : _a.formErrors.fieldErrors) !== null && _b !== void 0 ? _b : {};
            this.formErrors = (_d = (_c = result.error) === null || _c === void 0 ? void 0 : _c.formErrors.formErrors) !== null && _d !== void 0 ? _d : [];
        }
    }
    onSuccessfulSubmit(data) {
        throw new Error('Method not implemented. data: ' + JSON.stringify(data));
    }
}
__decorate([
    state()
], SgdfFormElement.prototype, "fieldErrors", void 0);
__decorate([
    state()
], SgdfFormElement.prototype, "formErrors", void 0);
//# sourceMappingURL=sgdf-element.js.map